import React from "react";
import styled from "styled-components";
import { StyledCellText } from "src/components/MyGarage/TableCompare/Cells/CellText";
import { EMPTY_VALUE_DASH } from "src/constants";

const StyledCellStrikethrough = styled(StyledCellText)`
    text-decoration: line-through;
`;

const CellStrikethrough = (showStrikethroughForMSRP: boolean) => ({
    title,
    value: [value, msrpEqualsPrice],
}: {
    title?: string;
    value: [string, boolean];
}) => {
    if (!showStrikethroughForMSRP || value === EMPTY_VALUE_DASH || msrpEqualsPrice) {
        return (
            <StyledCellText id="MSRPCellStrikethrough" title={title}>
                {value}
            </StyledCellText>
        );
    }

    return <StyledCellStrikethrough id="MSRPCellStrikethrough">{value}</StyledCellStrikethrough>;
};

export default CellStrikethrough;
